import {useNavigate} from "react-router-dom";
import useOptions from "../../hooks/gate/useOptions";
import LoadingScreen from "../LoadingScreen";
import PLATFORMS from "../../tools/defaults/Platforms";
import React, {useContext, useEffect, useState} from "react";

import Guid from "../Guid";
import {GateContext} from "../../tools/contexts/GateContext";
import servicesRoute from "../../tools/servicesRoute";
import AdvanceGuide from "../guide/AdvanceGuide";

const BusinessLicenseInquiryGate = () => {
    const navigate = useNavigate();
    const {
        id,
        serviceType,
        postToken,
        returnUrl,
        state,
        loading,
        handleLoading,
        handleGetPlatformLink,
        handleGetState,
        code,
        discountCode,
        handlePlatformGuard
    } = useContext(GateContext);
    const [showSlide, setShowSlide] = useState(false)

    //--------------use effects-------------------------
    useEffect(() => {
        if (code) {
            if (state) {
                handleGetState(state, (stateData) => {
                    const params = {
                        "panel_mode": stateData.panel_mode,
                        "platform_hash_id": id,
                        "code": code,
                        "service_type": serviceType,
                        "post_token": stateData.panel_mode ? null : sessionStorage.getItem('post_token')
                    }
                    handlePlatformGuard(params, (data) => {
                        //on success
                        sessionStorage.setItem('token', data.access_token);
                        sessionStorage.setItem('platformUser', JSON.stringify(data.platform_user));
                        sessionStorage.setItem('service_type', serviceType);
                        if (stateData.panel_mode) {
                            //get user post
                            navigate('/posts?serviceType=' + serviceType)
                        } else {
                            navigate(servicesRoute[serviceType].path, {
                                state: {
                                    access_token: data.access_token,
                                    platform: data.client_name,
                                    platform_user: data.platform_user,
                                    mobile: data.platform_user.phone_number,
                                    defaultService: serviceType,
                                }, replace: true
                            })
                        }

                    })
                })
            }
        } else  if (postToken) {
            setShowSlide(true)
        }else {
            setShowSlide(true)
        }
    }, [])


    const onConfirm = () => {
        localStorage.clear();
        sessionStorage.clear();
        if (id) {
            sessionStorage.setItem('id', id);
        }
        if (postToken) {
            sessionStorage.setItem('post_token', postToken);
        }
        if (returnUrl) {
            sessionStorage.setItem('return_url', returnUrl);
        }
        if(discountCode){
            sessionStorage.setItem('discount_code',discountCode)
        }
        handleLoading(true);
        const params = {
            "post_token": postToken ? postToken : null,
            "service_type": serviceType,
            "platform_hash_id": id,
            "panel_mode": !postToken

        }
        handleGetPlatformLink(params);

    }


    if (loading) {
        return <LoadingScreen/>
    }
    /*   if (showSlide && options && options?.length) {
           return <Guid closeGuid={onConfirm} theme="green" imageClass="w-6/12 md:w-3/12 lg:w-3/12 xl:w-2/12"
                        slides={options}/>
       }*/
    if (showSlide) {
        return <AdvanceGuide onFinish={onConfirm}/>
    }

    return <div>

    </div>
}
export default BusinessLicenseInquiryGate;